module.exports = __webpack_public_path__ + "media/needMoreCoin.5dfb91da.mp3";